package com.imobly.imobly.api.dto.viacep

import kotlinx.serialization.Serializable

@Serializable
data class ErrorViaCepDTO(val message: String = ""): ResponseMessageViaCep()
